/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../models/Document';
import { Operation } from '../models/common/Operation';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20Operation } from '../../openapi/v2/models/Oas20Operation';
import { Oas20VisitorAdapter } from '../../openapi/v2/visitors/Oas20VisitorAdapter';

/**
 * Finds the first path item.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends Oas20VisitorAdapter
 */
export class ConsumesProducesFinder extends Oas20VisitorAdapter {
    public consumes : Array<string>;

    public produces : Array<string>;

    /**
     * @see io.apicurio.datamodels.core.visitors.VisitorAdapter#visitDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    public visitDocument(node : Document) {
        let doc : Oas20Document = <Oas20Document>node;
        if(NodeCompat.isNullOrUndefined(this.consumes)) {
            this.consumes = doc.consumes;
        }
        if(NodeCompat.isNullOrUndefined(this.produces)) {
            this.produces = doc.produces;
        }
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.VisitorAdapter#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        this.consumes = (<Oas20Operation>node).consumes;
        this.produces = (<Oas20Operation>node).produces;
    }

    constructor() {
        super();
        if(this.consumes===undefined) this.consumes = null;
        if(this.produces===undefined) this.produces = null;
    }
}
ConsumesProducesFinder["__class"] = "io.apicurio.datamodels.core.visitors.ConsumesProducesFinder";
ConsumesProducesFinder["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




